import React, { useEffect, useMemo, useState } from "react";
import TitlePage from "../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import { ConsultaTotvsEmpresa, ConsultaTotvsEmpresaIndividual } from "../../../../backend/ConsultaTotvsEmpresa";
import ResponsiveDataTable from "../../../components/DataTable";
import LoadingSpinner from "../../../components/LoadinSpinner";
import InputGeral from "../../../components/InputGeral/Index";

import ContratoParceria from "../../../../lib/json/consultas/ContratoParceria.json"
import SelectEmpresa from "../../../components/Select/Empresa";

import { ErroMsg, RetornaUsuarioLogado, SucessoMsg, encryptAES, formatDateColumn, formatarComoMoeda, formatarMoeda2, parseLocaleNumber, retornaDescricaoConta } from "../../../contents/VariaveisGlobais";
import { useNavigate } from "react-router-dom";
import { format, startOfMonth, startOfYear } from "date-fns";
import { usePopUp } from "../../../components/BootBox";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import { useSessionStorageState } from "../../../../hooks/useSessionStorageState";
import ExportarExcel from "../../../components/ExportarExcel";
import { handleValorTotal } from "../../../components/GridCell/Preco";
import { handleFilialContratoParceria, handleFornecedorCPColumn, handleStatusCP } from "../../../components/GridCell/ContratoParceria";
import SelectComprador from "../../../components/Select/Comprador";
import SelectFornecedor from "../../../components/Select/Fornecedor";
import SelecaoItemContratoParceria from "../../../components/SelecaoItemContratoParceria";
import { toast } from "react-toastify";

function ListaContratoParceria(){
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    // define a exibição do Loading
    var tabelasDefault  = ContratoParceria.tabelas;
    var dataItensContratoParceria = []
    
    const navigate = useNavigate();
    const currentDate = new Date()
    const firstDayOfMonthDate = startOfMonth(currentDate);
    const usuarioLogado = RetornaUsuarioLogado()
    const usuarioProtheus = usuarioLogado.usuarioProtheus
    const usuarioComprador = (usuarioProtheus?.value || '');
    const [carregar, setCarregar] = useState(false);
    const [ready, setReady] = useState(false);
    const [data, setData]   = useState([]);
    const [dataItens, setDataItens]   = useState();
    const [empresa, setEmpresa] = useSessionStorageState("contratoParceriaEmpresa", {value: "",text: "", });
    const [contratoParceria, setContratoParceria] = useSessionStorageState("ContratoParceriaContratoParceria",'');
    const [dateDe, setDateDe] =  useSessionStorageState("contratoParceriaDateDe",format(firstDayOfMonthDate, 'yyyy-MM-dd'));
    const [dateAte, setDateAte] = useSessionStorageState("contratoParceriaDateAte",format(currentDate, 'yyyy-MM-dd'));
    const [campoFornecedor, setCampoFornecedor] = useSessionStorageState("contratoParceriaFornecedor",null);
    const [campoComprador, setCampoComprador] = useSessionStorageState("contratoParceriaComprador",{value: usuarioComprador, label: ''});
    const [disabledComprador, setDisabledComprador] = useState(!usuarioLogado.permissao.visualizarPedidoCompra)    

    var compradorContrato = {value: '', text: ''};
    var empresaCopiar = {value: '', text: ''};
    var cpOrigem = '';
    var empresaOrigem = '';

    const excelColumns = [
        {
          Header: 'Filial',
          accessor: "C3_FILIAL",
        },
        {
          Header: 'Número',
          accessor: "C3_NUM"
        },
        {
          Header: 'Fornecedor',
          accessor: 'C3_FORNECE',
        },
        {
          Header: 'Loja',
          accessor: 'C3_LOJA'
        },
        {
          Header: 'Nome Fornecedor',
          accessor: 'A2_NOME',
        },
        {
          Header: 'Emissão',
          accessor: 'C3_EMISSAO',
          Cell: formatDateColumn
        },
        {
          Header: 'Período Início',
          accessor: 'C3_DATPRI',
          Cell: formatDateColumn
        },
        {
          Header: 'Período Fim',
          accessor: 'C3_DATPRF',
          Cell: formatDateColumn
        },
        {
          Header: 'Comprador',
          accessor: 'Y1_NOME',
        },
        {
          Header: 'Condição Pagamento',
          accessor: 'E4_DESCRI',
        },
        {
          Header: 'Valor Total',
          accessor: "C3_TOTAL",
          Cell: handleValorTotal
        },
        {
          Header: 'Status',
          accessor: 'C3_CONAPRO',
          Cell: handleStatusCP
        }
    ]

    // Colunas do grid
    const columns = [
        {
          Header: 'Filial',
          accessor: "C3_FILIAL",
          Cell: (item) => handleFilialContratoParceria(item, DisparaBootBox, FechaBootBox, navigate),
        },
        {
          Header: 'Fornecedor',
          accessor: 'C3_FORNECE',
          Cell: handleFornecedorCPColumn
        },
        {
          Header: 'Emissão',
          accessor: 'C3_EMISSAO',
          Cell: formatDateColumn
        },
        {
          Header: 'Periodo',
          accessor: 'C3_DATPRI',
          Cell: (item) => {
            const { C3_DATPRF } = item.row.original
            const itemFim = {value: C3_DATPRF};

            return (
                <>
                    <p><strong>Inicio: </strong>{formatDateColumn(item)}</p>
                    <p><strong>Fim: </strong>{formatDateColumn(itemFim)}</p>
                </>
            )
        
          }
        },
        {
          Header: 'Valor Total',
          accessor: "C3_TOTAL",
          Cell: handleValorTotal
        },
        {
          Header: 'Status',
          accessor: "C3_CONAPRO",
          Cell: handleStatusCP
        },
    ];

    // WHERE/filtros da consulta do grid
    const retornaConsultaDefault = () => {
        var consultaDefault = ContratoParceria.consulta;
        let consultaFiltro = "AND C3_FILIAL = FILIAL(SC3) ";
        
        if(contratoParceria) {
            consultaFiltro += "AND C3_NUM = '"+contratoParceria+"' ";
        }
        if(campoFornecedor?.value) {
            consultaFiltro += "AND C3_FORNECE + C3_LOJA = '"+campoFornecedor.value+"' ";
        }
        if(campoComprador?.value) {
            consultaFiltro += "AND C3_USER = '"+campoComprador.value+"' ";
        }
        if(dateDe) {
            consultaFiltro += "AND C3_EMISSAO >= '"+dateDe.replaceAll('-','')+"' ";
        }
        if(dateAte) {
            consultaFiltro += "AND C3_EMISSAO <= '"+dateAte.replaceAll('-','')+"' ";
        }
        
        consultaFiltro += " GROUP BY C3_FILIAL, C3_NUM, C3_FORNECE, C3_LOJA, A2_NOME, C3_CONTATO, C3_EMISSAO, C3_DATPRI, C3_DATPRF, C3_USER, Y1_COD, Y1_NOME, C3_CONAPRO, C3_XTIPCOM, C3_XFLUXCP, DHK_DESCR, C3_COND, E4_DESCRI "
        consultaDefault = consultaDefault.replace('CAMPOS', ' , SUM(C3_TOTAL) C3_TOTAL ');
        return consultaDefault.replace('FILTRO', consultaFiltro);
    }

    // Processa consulta do grid
    const listaCP = async () => {
        var consultaDefault = retornaConsultaDefault();
        let empresaFilial = empresa.value ? empresa.value.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresa.value.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) : ''

        setCarregar(true);
        var retConsulta = await ConsultaTotvsEmpresaIndividual( consultaDefault, tabelasDefault, empresaFilial );
        
        if (retConsulta.error === '00'){
            let dataAux = retConsulta.data
            setData(dataAux);
        } 

        setCarregar(false);
    }

    useEffect( () => {
        listaCP()
    },[])

    const handleVisualizar = (row) =>{
        navigate(`./Visualizar/${row.original.C3_NUM}/${row.original.EMPRESA}${row.original.C3_FILIAL}`)
    }
    
    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.original.C3_NUM}/${row.original.EMPRESA}${row.original.C3_FILIAL}`)
    }

    const handleCopiar = (row) =>{
        const idRow = row.original.C3_NUM;
        const Mensagem = ( <>
                <SelectEmpresa
                    campoEmpresa={empresaCopiar}
                    onChangeEmpresa={(e) => {empresaCopiar = e}}
                />
            </>
        )
        
        const buttonsRender = [
            { variant: 'primary', action: handleConfirmaCopiar, label: 'Confirmar' },
            { variant: 'secondary', action: FechaBootBox, label: 'Cancelar' }
        ]
        
        cpOrigem = row.original.C3_NUM;
        empresaOrigem = row.original.EMPRESA + '' + row.original.C3_FILIAL;

        DisparaBootBox('Confirmar Copia para Filial Escolhida ?', Mensagem, buttonsRender, idRow, null)
    }

    const handleAlterarComprador = (row) =>{
        const {EMPRESA, C3_FILIAL, C3_NUM, C3_FORNECE, C3_LOJA, A2_NOME} = row.original
        const idRow = EMPRESA + '' + C3_FILIAL + '|' + C3_NUM + '|' + C3_FORNECE + '/' + C3_LOJA + '-' + A2_NOME;

        compradorContrato = {value: '', text: ''};

        const Mensagem = ( 
            <Row>
                <Col md="1">
                    <InputGeral
                        label="Filial"
                        tipo='text'
                        max="6"
                        value={C3_FILIAL}  // Define o valor do campo com base no estado
                        disabled={true}
                    />
                </Col>
                <Col md="2">
                    <InputGeral
                        label="Número"
                        tipo='text'
                        max="6"
                        value={C3_NUM}  // Define o valor do campo com base no estado
                        disabled={true}
                    />
                </Col>
                <Col md="3">
                    <InputGeral
                        label="Fornecedor"
                        tipo='text'
                        value={C3_FORNECE + '-' + C3_LOJA + ' ' + A2_NOME}  // Define o valor do campo com base no estado
                        disabled={true}
                    />
                </Col>
                <Col md="6">
                    <SelectComprador
                        changeComprador={handleCampoComprador}
                    />
                </Col>
            </Row>
        )
        
        const buttonsRender = [
            { variant: 'primary', action: handleConfirmaComprador, label: 'Confirmar' },
            { variant: 'secondary', action: FechaBootBox, label: 'Cancelar' }
        ]
        
        DisparaBootBox('Alteração do Comprador do Contrato', Mensagem, buttonsRender, idRow, null, 'xl')        
    }

    const handleCampoComprador = (e) =>{
        compradorContrato = e;
    }
    
    const handleConfirmaComprador = async(row) => {
        const empresaFilial = row.split('|')[0]
        const cJSONSalvar = { 
            Numero: row.split('|')[1],
            Fornecedor: {label: row.split('|')[2]},
            Comprador: compradorContrato
        }

        FechaBootBox()
        try {
            setCarregar(true);

            const oRetorno = await ConsumoTOTVS_POST('COMPRADORCONTRATOPARCERIA', cJSONSalvar, empresaFilial)
            
            if (oRetorno.error === '00'){
                SucessoMsg(oRetorno.description)
                await listaCP();
            }else{
                ErroMsg(oRetorno.description)
                return false;
            }
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
        }
    }

    const handleConfirmaCopiar = () => {  
        FechaBootBox()
        navigate(`./Copiar/${cpOrigem}/${empresaOrigem}/${empresaCopiar.value}`)
    }

    const handleExcluir = (row) =>{
        const {EMPRESA, C3_FILIAL, C3_NUM, C3_FORNECE, C3_LOJA, A2_NOME} = row.original
        const idRow = EMPRESA + '' + C3_FILIAL + '|' + C3_NUM + '|' + C3_FORNECE + '/' + C3_LOJA;
        
        const Mensagem = `Tem certeza que deseja excluir o Contrato de Parceria ${C3_NUM + '</br> Fornecedor: ' + C3_FORNECE + '/' + C3_LOJA + ' - ' + A2_NOME + ' / Filial: ' + C3_FILIAL}?`
        
        DisparaBootBox('Confirma Exclusão ?', Mensagem, null, idRow, handleExcluirConfirm)
    };

    const handleExcluirConfirm = async(row) => {
        const empresaFilial = row.split('|')[0]
        const cJSONSalvar = { 
            Numero: row.split('|')[1],
            Item: "",
            Fornecedor: row.split('|')[2], 
        }

        FechaBootBox()
        try {
            setCarregar(true);

            const oRetorno = await ConsumoTOTVS_POST('EXCLUIRCONTRATOPARCERIA', cJSONSalvar, empresaFilial)
            
            if (oRetorno.error === '00'){
                SucessoMsg("Excluído com Sucesso")
                await listaCP();
            }else{
                ErroMsg(oRetorno.description)
                return false;
            }
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
        }
    };

    const excelHeaders = useMemo(() => {
        return excelColumns.map(col => col.Header);
    }, [excelColumns]);

    const excelRows = useMemo(() => {
        return data.map(item =>
            excelColumns.map(col => {
                const value = item[col.accessor];

                if (col.Cell) {
                    return col.Cell({ value, row: { original: item } });
                }
                return value ?? ""; // valor padrão se undefined/null
            })
        );
    }, [data, excelColumns]);

    const handleApontamentoEntrega = async(row) => {
        setCarregar(true);

        const {EMPRESA, C3_FILIAL, C3_NUM, C3_FORNECE, C3_LOJA} = row.original
        let cEmpresaFilial = EMPRESA + '' + C3_FILIAL
        
        let consulta = ContratoParceria.consulta

        let cFiltro = "AND C3_FILIAL = FILIAL(SC3) ";
        cFiltro += "AND C3_NUM = '" + C3_NUM + "'";
        cFiltro += "AND C3_FORNECE = '" + C3_FORNECE + "'";
        cFiltro += "AND C3_LOJA = '" + C3_LOJA + "'";
        cFiltro += "AND C3_QUANT > C3_QUJE";

        let cCampos = " , C3_TPFRETE, A2_CGC, C3_MOEDA, C3_PRODUTO, CASE WHEN B5_CEME != '' THEN B5_CEME ELSE B1_DESC END AS DESCRI, B1_DESC, C3_LOCAL, NNR_DESCRI, C3_CC"
        cCampos += " , CONVERT(VARCHAR(8000),CONVERT(VARCHAR(8000),CONVERT(VARBINARY(8000),C3_XANXCP))) C3_XANXCP"
        cCampos += " , CONVERT(VARCHAR(8000),CONVERT(VARCHAR(8000),CONVERT(VARBINARY(8000),C3_XANEXO))) C3_XANEXO"
        cCampos += " , CTT_DESC01, CTT_XTIPO, CTT_CEP, CTT_ENDER, CTT_BAIRRO, CTT_MUNIC, CTT_ESTADO"
        cCampos += " , C3_ITEM, C3_UM, C3_OBS, C3_QUANT, C3_PRECO, C3_TOTAL, C3_XPRAZO, C3_XCA, C3_QUJE"
        cCampos += " , B1_CONTA, BM_XCTAVLO, BM_XCTCONO, BM_XCTLOCO, BM_XCTSERO, BM_XCTEPIO, BM_XCTREVO, BM_XCTATVO, BM_XCTBRNO, BM_XCTIEXO, BM_XCTISBO, BM_XCTIMNO"
        cCampos += " , B1_XCONTA, BM_XCTAVLC, BM_XCTCONC, BM_XCTLOCC, BM_XCTSERC, BM_XCTEPIC, BM_XCTREVC, BM_XCTATVC, BM_XCTBRNC, BM_XCTIEXC, BM_XCTISBC, BM_XCTIMNC"

        consulta = consulta.replace("FILTRO", cFiltro)
        consulta = consulta.replace("CAMPOS", cCampos)
        
        const retConsulta = await ConsultaTotvsEmpresa(consulta, ContratoParceria.tabelas, cEmpresaFilial)
        
        if (retConsulta.data){
            if (retConsulta.data.length > 0){
                await retornaDescricaoConta(""); //Processa para gerar o array das contas
                dataItensContratoParceria = await Promise.all(retConsulta.data.map( async(item) => { 
                    const contabil = [
                        { finalidade: 'Produto',                                          operacional: item.B1_XCONTA,     corporativo: item.B1_CONTA  },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_APLICACAO,       operacional: item.BM_XCTAVLO,   corporativo: item.BM_XCTAVLC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_CONSUMO,         operacional: item.BM_XCTCONO,   corporativo: item.BM_XCTCONC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_LOCACOES,        operacional: item.BM_XCTLOCO,   corporativo: item.BM_XCTLOCC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_SERVICOS,        operacional: item.BM_XCTSERO,   corporativo: item.BM_XCTSERC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_EPI,             operacional: item.BM_XCTEPIO,   corporativo: item.BM_XCTEPIC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_REVENDA,         operacional: item.BM_XCTREVO,   corporativo: item.BM_XCTREVC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_ATIVO,           operacional: item.BM_XCTATVO,   corporativo: item.BM_XCTATVC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_BRINDE,          operacional: item.BM_XCTBRNO,   corporativo: item.BM_XCTBRNC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_EXTRAVIO,        operacional: item.BM_XCTIEXO,   corporativo: item.BM_XCTIEXC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_SUBSTITUICAO,    operacional: item.BM_XCTISBO,   corporativo: item.BM_XCTISBC },
                        { finalidade: window._env_?.REACT_APP_FINALIDADE_MANUTENCAO,      operacional: item.BM_XCTIMNO,   corporativo: item.BM_XCTIMNC }
                    ]
                    
                    let contaProduto = (item.CTT_XTIPO === "2" ? contabil[0].operacional : contabil[0].corporativo).trim()
                    let contaFinalidadeGrupo = contabil.filter( (itemContabil) => itemContabil.finalidade === item.C3_XTIPCOM )
                    contaProduto = contaProduto ? contaProduto : ( contaFinalidadeGrupo.length > 0 ? ( item.CTT_XTIPO === "2" ? contaFinalidadeGrupo[0].operacional : contaFinalidadeGrupo[0].corporativo ) : "" ).trim()

                    const saldo = parseFloat(item.C3_QUANT) - parseFloat(item.C3_QUJE)
                    const total = ( Number(saldo) * Number(item.C3_PRECO) )
                    const descricaoProduto = await retornaDescricaoConta(contaProduto)
                    
                    item.item    = item.C3_ITEM
                    item.QTDSEL  = formatarMoeda2(saldo,4);
                    item.TOTAL   = formatarMoeda2(total,2);
                    item.Check   = false; 
                    item.CNTPROD = contabil
                    item.LOCAL   = {value: item.C3_LOCAL, label: item.C3_LOCAL + ' - ' + item.NNR_DESCRI, origem: {CTT_XTIPO: item.CTT_XTIPO, CTT_DESC01: item.CTT_DESC01, NNR_XCC: item.C3_CC}}
                    item.CC      = {value: item.C3_CC, label: item.C3_CC.trim() + ' - ' + item.CTT_DESC01.trim()}
                    item.ENTREGA = item.CTT_CEP + ' - ' + item.CTT_ENDER + ', ' + item.CTT_BAIRRO + ' - ' +  item.CTT_MUNIC + '/' + item.CTT_ESTADO
                    item.CONTA   = {value: contaProduto.trim(), label: contaProduto.trim() + ' - ' + descricaoProduto }

                    return item 
                }));
                
                setDataItens(dataItensContratoParceria);
            }
        }
                
        if (dataItensContratoParceria.length > 0){
            setReady(true);
        }

        setCarregar(false);
    }

    function formatarImposto(obj) {
        obj.BASE = formatarMoeda2(parseFloat(obj.BASE),2);
        obj.ALIQUOTA = formatarMoeda2(parseFloat(obj.ALIQUOTA),2);
        obj.VALOR = formatarMoeda2(parseFloat(obj.VALOR),2);

        return obj;
    }

    const GerarAutEntrega = async() => {
        const ItensSalvar = dataItens.filter((item) => item.Check == true )
        
        if (ItensSalvar.length > 0) {
            setCarregar(true)
            const observacao = ItensSalvar[0].OBSERVACAO
            const empresaFilial = ItensSalvar[0].EMPRESA + '' + ItensSalvar[0].C3_FILIAL
            
            if (!observacao){
                toast.warning('Preenchimento da Observação é obrigatório.');
                return false
            }else{
                FechaBootBox()
                const dataItensSalvar = await Promise.all(ItensSalvar.map( async(item, index) => { 
                    const empresaFilial = item.EMPRESA + '' + item.C3_FILIAL
                    const Fornecedor = {value: item.C3_FORNECE + '' + item.C3_LOJA, label: item.C3_FORNECE + '/' + item.C3_LOJA + ' - ' + item.A2_NOME.trim() + '(' + item.A2_CGC.trim() + ')'};
                    const nTotalProduto = parseLocaleNumber(item.TOTAL)
                    const valorUnitario = formatarMoeda2(parseFloat(item.C3_PRECO),2)
                    const totalItem = parseFloat((nTotalProduto).toFixed(2),2)
                    const data = new Date(currentDate);
                    const dataEntrega = data.setDate(data.getDate() + Number(item.C3_XPRAZO));

                    const jsonEnvio = {
                        FORNECEDOR: Fornecedor.value.substr(0,6),
                        LOJA: Fornecedor.value.substr(6,4),
                        PRODUTO: item.C3_PRODUTO,
                        QUANTIDADE: item.QTDSEL,
                        PRECO: valorUnitario,
                        TOTAL: totalItem,
                        FINALIDADE: item.C3_XTIPCOM
                    }
                    
                    const retornoCalculaImposto = await ConsumoTOTVS_POST('CALCULAIMPOSTO', jsonEnvio, empresaFilial)
                    const retImposto = retornoCalculaImposto?.data || [];

                    const hoje = new Date()

                    let newItem = {}
                    newItem.produto = {value: item.C3_PRODUTO, label: item.C3_PRODUTO + ' - ' + item.DESCRI, descricaoBD: item.B1_DESC };
                    newItem.unidadeMedida = item.C3_UM;
                    newItem.descricaoComplementar = item.C3_OBS;
                    newItem.campoArmazem = item.LOCAL;
                    newItem.campoContaContabil = item.CONTA;
                    newItem.campoCentroCusto = item.CC;
                    newItem.campoCentroCustoReposicao = {value: '', label: 'Selecione o Centro de Custo de Reposição'};
                    newItem.enderecoEntrega = item.ENTREGA;
                    newItem.quantidade = item.QTDSEL;
                    newItem.valorUnitario = valorUnitario;
                    newItem.valorTotal = nTotalProduto;
                    newItem.certificado = item.C3_XCA;
                    newItem.numeroNF = '';
                    newItem.icms = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'ICMS')[0]);
                    newItem.ipi = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'IPI')[0]);
                    newItem.pis = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'PIS')[0]);
                    newItem.cofins = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'COFINS')[0]);
                    newItem.iss = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'ISS')[0]);
                    newItem.irrf = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'IRRF')[0]);
                    newItem.inss = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'INSS')[0]);
                    newItem.csll = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'CSLL')[0]);
                    newItem.difal = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'DIFAL')[0]);
                    newItem.icmsST = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'ICMSST')[0]);
                    newItem.solicitacao = item.C3_NUM;
                    newItem.item = String(index + 1).padStart(4, '0');
                    newItem.itemSolicitacao = item.C3_ITEM;
                    newItem.anexoItem = '[]';
                    newItem.deletado = false;
                    newItem.numero = '';
                    newItem.fornecedor = Fornecedor;
                    newItem.emissao = format(hoje, 'yyyy-MM-dd');
                    newItem.entrega = format(dataEntrega, 'yyyy-MM-dd');
                    newItem.comprador = {value: item.C3_USER, label: item.Y1_COD + ' - ' + item.Y1_NOME};
                    newItem.finalidade = {value: item.C3_XTIPCOM, label: item.C3_XTIPCOM + " - " + item.DHK_DESCR, origem: { DHK_XPRDIN: item.DHK_XPRDIN, DHK_XPRDFN: item.DHK_XPRDFN, DHK_XDSLA: item.DHK_XDSLA, DHK_XGRPRD: item.DHK_XGRPRD} } ;
                    newItem.prioridade = {value: (item.C3_XFLUXCP.trim() || "1"), text: "" };
                    newItem.condicaoPagamento = {value: item.C3_COND, label: item.C3_COND + ' - ' + item.E4_DESCRI};
                    newItem.enviaEmail = "S";
                    newItem.moeda = {value: item.C3_MOEDA.toString(), label: ''};
                    newItem.tipoFrete = {value: item.C3_TPFRETE, text: ''};
                    newItem.valorFrete = 0;
                    newItem.desconto = 0;
                    newItem.percentualDesconto = 0;
                    newItem.justificativa = ''; 
                    newItem.observacao = item.OBSERVACAO; 
                    newItem.anexoPC = '[]'; 
                    newItem.totalItem = totalItem;
                    newItem.solicitante = usuarioComprador;

                    return newItem
                }))
                
                const cJSONSalvar = JSON.stringify(dataItensSalvar)
                
                const oRetorno = await ConsumoTOTVS_POST('NOVAAUTORIZACAOENTREGA', cJSONSalvar, empresaFilial)

                setCarregar(false)
                if (oRetorno.error === '00'){
                    SucessoMsg(oRetorno.description)
                }else{
                    ErroMsg(oRetorno.description)
                }
            }
        }
    }

    useEffect(() => {
        if (ready && dataItens.length > 0) {
            setReady(false); // evita loop
            SelecaoItemContratoParceria(DisparaBootBox, GerarAutEntrega, dataItens, setDataItens, FechaBootBox )
            
        }
    }, [ready, dataItens]);

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage text="Contrato de Parceria"/>
                </Col>
                <Col md='4'>
                    <SelectEmpresa
                        campoEmpresa={empresa}
                        onChangeEmpresa={setEmpresa}
                    />
                </Col>
                 <Col md="8" xs="12">
                    <SelectFornecedor
                        campoFornecedor={campoFornecedor}
                        changeFornecedor={setCampoFornecedor}
                        empresaLogada={empresa.value}
                    />
                </Col>
            </Row>
            <Row>
                <Col md="2" xs="12">
                    <InputGeral 
                        label="Contrato de Parceria"
                        tipo='text'
                        max="6"
                        value={contratoParceria}  // Define o valor do campo com base no estado
                        onChange={(e) => setContratoParceria(e.target.value)}
                    />
                </Col>
                
                <Col md="2" xs="12">
                    <InputGeral
                        label="Emissão de"
                        tipo='date'
                        value={dateDe}
                        onChange={(e) => setDateDe(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Emissão até"
                        tipo='date'
                        value={dateAte}
                        onChange={(e) => setDateAte(e.target.value)}
                    />
                </Col>                  
                <Col md="3" xs="12">
                    <SelectComprador
                        campoComprador={campoComprador}
                        changeComprador={setCampoComprador}
                        empresaLogada={empresa.value}
                        disabled={disabledComprador}
                    />
                </Col>
            </Row>
            <Row className="d-flex justify-content-end">
                <Col md="3" xs="12">
                    <Button 
                        variant="outline-primary" 
                        type="submit" 
                        onClick={listaCP}
                        className="w-100"
                    >
                        Buscar
                    </Button>
                </Col>
                <Col md="3" xs="12">
                    <ExportarExcel 
                        nomeArquivo="Contrato_de_Parceria"
                        headers={excelHeaders}
                        rows={excelRows}
                    />
                </Col>
            </Row>
            
            <Row>
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons={[
                            {isVisual: true, action: handleVisualizar, label: "Visualizar", icone: "MdOutlinePreview", style: "light"}, 
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote" }, 
                            {isExcluir: true, action: handleExcluir, label: "Excluir", icone: "MdPlaylistRemove", style: "danger" },
                            {isAlterar: true, action: handleAlterarComprador, label: "Comprador", icone: "MdOutline3P" }, 
                            {isAlterar: true, action: handleCopiar, label: "Copiar", icone: "MdOutlineCopyAll", style: "success"},
                            {isVisual: true, action: handleApontamentoEntrega, label: "Medição", icone: "MdPlaylistPlay", style: "success", regraExclude: "!(Number(`${new Date().getFullYear()}${String(new Date().getMonth()+1).padStart(2,'0')}${String(new Date().getDate()).padStart(2,'0')}`) >= Number(row.original.C3_DATPRI) && Number(`${new Date().getFullYear()}${String(new Date().getMonth()+1).padStart(2,'0')}${String(new Date().getDate()).padStart(2,'0')}`) <= Number(row.original.C3_DATPRF) && row.original.C3_CONAPRO == 'L')" }
                        ]}
                    />
                </Col>
            </Row>
        </>
    );
}

export default ListaContratoParceria;


